export const BEST_SELLERS = '<BEST_SELLERS>';
export const partitionConflicts = [
    {
      categoryId: BEST_SELLERS,
      name: 'Best Sellers'
    }
  ];